// Foroom theme script: mural shapes, apartment filters, gallery, home page numbers.
const C = { blue: "#1d49a0", teal: "#1fa6a8", sea: "#1b6f92", red: "#d9283b", orange: "#f0502a", pink: "#c7336f", yellow: "#f8ba1a" };
const SVG = {
  flower: `<svg viewBox="0 0 140 130"><g fill="${C.red}">${[-72, -36, 0, 36, 72].map((r) => `<ellipse cx="70" cy="62" rx="13" ry="40" transform="rotate(${r} 70 112)"/>`).join("")}</g></svg>`,
  leaf: `<svg viewBox="0 0 160 160" fill="none" stroke="${C.teal}" stroke-width="26" stroke-linecap="round" stroke-linejoin="round"><path d="M24 138 Q70 92 136 24"/><path d="M52 30 Q100 16 138 22 Q146 62 132 108"/></svg>`,
  dots: `<svg viewBox="0 0 120 100" fill="${C.blue}">${[[12, 60], [30, 30], [38, 72], [55, 48], [62, 14], [74, 78], [86, 38], [98, 64], [108, 20], [20, 90]].map(([x, y]) => `<circle cx="${x}" cy="${y}" r="6"/>`).join("")}</svg>`,
  pill: `<svg viewBox="0 0 150 110">${[0, 60].map((y) => `<rect x="0" y="${y}" width="150" height="46" rx="23" fill="${C.orange}"/>${[26, 50, 74, 98, 122].map((x) => `<rect x="${x - 6}" y="${y + 9}" width="12" height="28" fill="${C.yellow}"/>`).join("")}`).join("")}</svg>`,
  squiggle: `<svg viewBox="0 0 80 200" fill="none" stroke="${C.orange}" stroke-width="22" stroke-linecap="round"><path d="M50 16 Q4 56 34 100 T36 184"/></svg>`,
  sun: `<svg viewBox="0 0 160 160"><circle cx="80" cy="80" r="78" fill="${C.pink}"/><g stroke="${C.blue}" stroke-width="5" stroke-linecap="round">${[[30, 26], [58, 6], [86, 3], [114, 8], [142, 30]].map(([y, i]) => `<path d="M${i + 4} ${y} L${156 - i} ${y - 10}"/>`).join("")}</g></svg>`,
  arc: `<svg viewBox="0 0 170 190"><path d="M36 10 Q20 150 160 168" fill="none" stroke="${C.yellow}" stroke-width="56" stroke-linecap="round"/>${[[36, 26], [34, 70], [46, 110], [74, 140], [112, 158], [150, 166]].map(([x, y]) => `<circle cx="${x}" cy="${y}" r="10" fill="${C.blue}"/><circle cx="${x}" cy="${y}" r="3" fill="${C.yellow}"/>`).join("")}</svg>`,
  grid: `<svg viewBox="0 0 80 120" fill="${C.teal}">${[20, 60, 100].map((y) => `<circle cx="20" cy="${y}" r="15"/><circle cx="60" cy="${y}" r="15"/>`).join("")}</svg>`,
};
const shape = (name, css) => `<span class="shape" aria-hidden="true" style="${css}">${SVG[name] || ""}</span>`;
const money = (n) => "$" + Math.round(n).toLocaleString("en-US");
const $ = (s, el = document) => el.querySelector(s);
const $$ = (s, el = document) => [...el.querySelectorAll(s)];

// data-deco="name|css&&name|css" puts mural shapes behind an element's content.
$$("[data-deco]").forEach((el) => {
  el.classList.add("deco");
  el.insertAdjacentHTML("afterbegin", el.dataset.deco.split("&&").map((d) => { const [n, css] = d.split("|"); return shape(n, css); }).join(""));
});
$$("[data-shape]").forEach((el) => { el.innerHTML = SVG[el.dataset.shape] || ""; });

const menu = $(".menu-btn");
if (menu) menu.addEventListener("click", () => $(".nav").classList.toggle("open"));

// Home page numbers, built from the apartment list the theme prints as JSON.
const data = $("#apts") ? JSON.parse($("#apts").textContent) : [];
const open = data.filter((a) => a.st === "Available");
const pp = (a) => a.rent / a.beds;
const all = window.FOROOM_ALL_URL || "/collections/all";
if ($("#stats") && data.length) {
  const buildings = new Set(data.map((a) => a.b)).size;
  const minPP = open.length ? Math.min(...open.map(pp)) : 0;
  $("#stats").innerHTML = [[open.length, "apartments open now"], ["2 to 7", "bedrooms per apartment"], [money(minPP), "per bedroom, starting rent"], [buildings, "buildings we own and manage"]]
    .map(([b, s]) => `<div class="stat"><b>${b}</b><span>${s}</span></div>`).join("");
  $$("[data-count]").forEach((el) => { el.textContent = { total: data.length, open: open.length, buildings }[el.dataset.count]; });
}
if ($("#sizes")) {
  $("#sizes").innerHTML = [[2, "2"], [3, "3"], [4, "4"], [5, "5"], [6, "6 to 7"]].map(([n, label]) => {
    const set = open.filter((a) => (n === 6 ? a.beds >= 6 : a.beds === n));
    if (!set.length) return "";
    return `<a class="size" href="${all}?beds=${n}"><b>${label}</b><small>bedrooms</small><em>${set.length} open</em><small>from ${money(Math.min(...set.map(pp)))} per person</small></a>`;
  }).join("");
}
if ($("#streets")) {
  const names = { Hoffman: "Hoffman Street", Cambreleng: "Cambreleng Avenue", Lorillard: "Lorillard Place", Hughes: "Hughes Avenue" };
  $("#streets").innerHTML = Object.keys(names).map((s) => {
    const set = open.filter((a) => a.s === s);
    if (!set.length) return "";
    return `<a class="street" href="${all}?street=${s}"><b>${names[s]}</b><span>${set.length} open · ${Math.min(...set.map((a) => a.beds))} to ${Math.max(...set.map((a) => a.beds))} bedrooms</span></a>`;
  }).join("");
}
if ($("#ticker")) $("#ticker").innerHTML += $("#ticker").innerHTML;

// Shared map code (apartment list and home page). Leaflet loads only when a map is needed.
const STREET = { Hoffman: C.blue, Cambreleng: C.teal, Lorillard: C.orange, Hughes: C.pink };
const pair = (t) => { const [a, b] = (t || "").split(",").map(Number); return a && b ? [a, b] : null; };
const loadLeaflet = () => new Promise((res) => {
  if (window.L) return res();
  const l = document.createElement("link"); l.rel = "stylesheet"; l.href = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.css"; document.head.appendChild(l);
  const sc = document.createElement("script"); sc.src = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js"; sc.onload = res; document.head.appendChild(sc);
});
function makeMap(box) {
  const map = L.map(box, { scrollWheelZoom: false });
  L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", { maxZoom: 19, attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' }).addTo(map);
  return { map, layer: L.layerGroup().addTo(map), fitted: "" };
}
// items: apartments to show. all: every apartment, used to find a building's coordinates.
function drawPins(m, box, items, all) {
  m.layer.clearLayers();
  const geo = {}, groups = {}, pts = [];
  all.forEach((a) => { const g = pair(a.geo); if (g) geo[a.b] = g; });
  items.forEach((a) => (groups[a.b] = groups[a.b] || []).push(a));
  Object.keys(groups).forEach((b) => {
    const g = geo[b], list = groups[b];
    if (!g) return;
    const icon = L.divIcon({ className: "", html: `<span class="pin" style="border-color:${STREET[list[0].s] || C.blue}">${list.length}</span>`, iconSize: [40, 40], iconAnchor: [20, 20] });
    const rows = list.map((a) => `<a href="${a.href}"><b>Unit ${a.unit}</b><span>${a.beds} bed · ${a.price}</span><em class="${a.open ? "" : "off"}">${a.label}</em></a>`).join("");
    L.marker(g, { icon }).bindPopup(`<div class="pop"><h4>${b}</h4>${rows}</div>`, { maxWidth: 290, minWidth: 220 }).addTo(m.layer);
    pts.push(g);
  });
  const campus = pair(box.dataset.campus);
  if (campus) { L.marker(campus, { interactive: false, icon: L.divIcon({ className: "", html: `<span class="campus">${box.dataset.campusLabel}</span>`, iconSize: [170, 32], iconAnchor: [85, 16] }) }).addTo(m.layer); pts.push(campus); }
  const key = pts.join("|");
  if (pts.length && key !== m.fitted) { m.map.fitBounds(L.latLngBounds(pts).pad(0.12)); m.fitted = key; }
}

// Home page map: open apartments only. Starts loading when it scrolls near the screen.
const homeMap = $("#homeMap");
if (homeMap && data.length) {
  const toItem = (a) => ({ b: a.b, s: a.s, unit: a.u, beds: a.beds, price: money(a.rent), open: a.st === "Available", label: a.af * 1000 > Date.now() ? "Available " + new Date(a.af * 1000).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "Available now", href: a.url, geo: a.g });
  const start = () => loadLeaflet().then(() => drawPins(makeMap(homeMap), homeMap, open.map(toItem), data.map(toItem)));
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver((e) => { if (e.some((x) => x.isIntersecting)) { io.disconnect(); start(); } }, { rootMargin: "400px" });
    io.observe(homeMap);
  } else start();
}

// Apartment page map: the building and the campus. Starts loading when it scrolls near the screen.
const locMap = $("#aptLocMap");
if (locMap) {
  const start = () => loadLeaflet().then(() => {
    const g = pair(locMap.dataset.geo), campus = pair(locMap.dataset.campus);
    if (!g) return;
    const map = L.map(locMap, { scrollWheelZoom: false, dragging: !L.Browser.mobile, tap: false });
    L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", { maxZoom: 19, attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' }).addTo(map);
    const color = STREET[locMap.dataset.street] || C.blue;
    L.marker(g, { icon: L.divIcon({ className: "", html: `<span class="pin pin-home" style="border-color:${color}"></span>`, iconSize: [40, 40], iconAnchor: [20, 20] }) })
      .bindTooltip(locMap.dataset.label, { permanent: true, direction: "top", offset: [0, -20], className: "loc-tip" }).addTo(map);
    const pts = [g];
    if (campus) { L.marker(campus, { interactive: false, icon: L.divIcon({ className: "", html: `<span class="campus">${locMap.dataset.campusLabel}</span>`, iconSize: [170, 32], iconAnchor: [85, 16] }) }).addTo(map); pts.push(campus); }
    map.fitBounds(L.latLngBounds(pts).pad(0.25), { maxZoom: 16 });
  });
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver((e) => { if (e.some((x) => x.isIntersecting)) { io.disconnect(); start(); } }, { rootMargin: "400px" });
    io.observe(locMap);
  } else start();
}

// Apartment list filters. Cards are printed by the theme; this only shows, hides and sorts them.
const grid = $("#aptGrid");
if (grid) {
  const q = new URLSearchParams(location.search);
  const state = { beds: q.get("beds") || "", street: q.get("street") || "", pp: q.get("pp") || "", status: q.get("status") || "", sort: "pp" };
  const cards = $$(".card", grid);
  const num = (c, k) => +c.dataset[k];
  const draw = () => {
    $$("#beds .chip").forEach((b) => b.setAttribute("aria-pressed", b.dataset.v === state.beds));
    const sorts = { pp: (a, b) => num(a, "pp") - num(b, "pp"), rent: (a, b) => num(a, "rent") - num(b, "rent"), beds: (a, b) => num(b, "beds") - num(a, "beds") || num(a, "rent") - num(b, "rent"), photos: (a, b) => num(b, "photos") - num(a, "photos") };
    let shown = 0, openN = 0;
    cards.sort((a, b) => num(b, "open") - num(a, "open") || (num(b, "photos") > 0) - (num(a, "photos") > 0) || sorts[state.sort](a, b)).forEach((c) => {
      const ok = (!state.beds || (state.beds === "6" ? num(c, "beds") >= 6 : num(c, "beds") === +state.beds)) && (!state.street || c.dataset.street === state.street) && (!state.pp || num(c, "pp") <= +state.pp) && (!state.status || c.dataset.status === state.status);
      c.hidden = !ok;
      if (ok) { shown++; if (c.dataset.open === "1") openN++; }
      grid.appendChild(c);
    });
    $("#empty").hidden = shown > 0;
    $("#count").innerHTML = `<b>${shown}</b> ${shown === 1 ? "apartment" : "apartments"}` + (state.status ? "" : ` · ${openN} open now`);
    const p = new URLSearchParams();
    ["beds", "street", "pp", "status"].forEach((k) => state[k] && p.set(k, state[k]));
    if (state.view === "map") p.set("view", "map");
    history.replaceState(null, "", p.toString() ? "?" + p : location.pathname);
    drawMap();
  };

  // Map view: one pin per building, built from the cards that pass the filters.
  const box = $("#aptMap");
  const item = (c) => ({ b: c.dataset.building, s: c.dataset.street, unit: c.dataset.unit, beds: c.dataset.beds, price: c.dataset.price, open: c.dataset.open === "1", label: c.dataset.label, href: c.href, geo: c.dataset.geo });
  let m;
  function drawMap() { if (m) drawPins(m, box, cards.filter((c) => !c.hidden).map(item), cards.map(item)); }
  const setView = (v) => {
    state.view = v;
    $$("#view .chip").forEach((b) => b.setAttribute("aria-pressed", b.dataset.view === v));
    $("#aptMapWrap").hidden = v !== "map";
    if (v !== "map") return draw();
    loadLeaflet().then(() => { if (!m) m = makeMap(box); m.map.invalidateSize(); draw(); });
  };
  $("#view").addEventListener("click", (e) => { if (e.target.dataset.view) setView(e.target.dataset.view); });
  $("#beds").addEventListener("click", (e) => { if (e.target.dataset.v !== undefined) { state.beds = e.target.dataset.v; draw(); } });
  ["street", "pp", "status", "sort"].forEach((k) => { $("#" + k).value = state[k]; $("#" + k).addEventListener("change", (e) => { state[k] = e.target.value; draw(); }); });
  if (q.get("view") === "map") setView("map"); else draw();
}

// Apartment page gallery.
$$(".thumbs button").forEach((b) => b.addEventListener("click", () => {
  $("#mainImg").src = b.dataset.src;
  $$(".thumbs button").forEach((x) => x.setAttribute("aria-current", x === b));
}));

// Tour form: a link like /pages/contact?apartment=2492%20Cambreleng%20Ave fills in the apartment field.
const aptField = $("#tourApartment"), aptParam = new URLSearchParams(location.search).get("apartment");
if (aptField && aptParam && !aptField.value) aptField.value = aptParam;
